export const START_FETCH_COURSES_PAGE_DATA = "START_FETCH_COURSES_PAGE_DATA";
export const SUCCESS_FETCH_COURSES_PAGE_DATA =
  "SUCCESS_FETCH_COURSES_PAGE_DATA";
export const ERROR_FETCH_COURSES_PAGE_DATA = "ERROR_FETCH_COURSES_PAGE_DATA";

export const START_FETCH_ONLINE_COURSE_DATA = "START_FETCH_ONLINE_COURSE_DATA";
export const SUCCESS_FETCH_ONLINE_COURSE_DATA =
  "SUCCESS_FETCH_ONLINE_COURSE_DATA";
export const ERROR_FETCH_ONLINE_COURSE_DATA = "ERROR_FETCH_ONLINE_COURSE_DATA";
